'use strict'

import React,{Component} from 'react';

export default class IssueMenu extends React.Component {
  render() {
    let languageLabels={
      norwegian: {
        reportOptions: "Rapportvalg",
        publishReport: "Publiser rapport",
      },
      english: {
        reportOptions: "Report Options",
        publishReport: "Publish Report",
      }
    };
    let labels=(languageLabels[this.props.language] || languageLabels["english"]);

    var reports=this.props.reports; //{id: uuid.v4(),date:new Date()}];
    return (
      <div style={{display:"inline-block", float: "right",marginRight: 30, width:250, borderLeft: "solid lightgrey 1px", paddingTop: 10, paddingLeft:10, paddingBottom: 150}}>
        <div style={{paddingTop:15}}>
          <b>{labels.reportOptions}</b>
          <div style={{paddingLeft:10}}>
            <div style={{cursor: "pointer", textDecoration: "underline"}} onClick={this.props.publishReport}>{labels.publishReport}</div>
          </div>
        </div>
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./views/progress/ReportMenu.jsx